import React, { useRef, useState, useEffect } from 'react';
import '../styles/carousel.scss';
import { useSwipeable } from 'react-swipeable';
import photo0 from '../assets/nextGeneration/chloe.png';
import photo1 from '../assets/nextGeneration/shifa.png';
import photo2 from '../assets/nextGeneration/keziah.png';
import photo3 from '../assets/nextGeneration/obiaku.png';
import photo4 from '../assets/nextGeneration/varuna.png';
import photo5 from '../assets/nextGeneration/jenna.png';
import photo6 from '../assets/nextGeneration/valini.png';
import photo7 from '../assets/nextGeneration/bhavishyaa.png';
import photo8 from '../assets/nextGeneration/nwanyabuife.png';
import arrow from '../assets/nextGeneration/carouselArrow.png';

function Carousel({ showArrow }) {
  const photos = [
    {
      img: photo0,
      name: 'Chloë, 13',
      caption:
        'Satellites! Mars! Stars! I want to see all kinds of space magic. Join a space exploration team. Wear the suit.'
    },
    {
      img: photo1,
      name: 'Shifa, 15',
      caption:
        'We should send mathematicians, philosophers, politicians, biologists, computer scientists, so that all voices are heard and nobody monopolizes space discovery for their own narrow desires.'
    },
    {
      img: photo2,
      name: 'Keziah, 13',
      caption:
        "Spacesuits are cool because they are like mini spaceships and they keep you alive while you're in space."
    },
    {
      img: photo3,
      name: 'Obiaku, 12',
      caption:
        "It is important to send all types of gender and people of color, because for over 50 years it's mainly men that have gone to space and we need men and women of color to go to space."
    },
    {
      img: photo4,
      name: 'Varuna, 9',
      caption:
        'Space is exciting because it is unpredictable. You don’t know what you will discover, or the impact it will make on our planet.'
    },
    {
      img: photo5,
      name: 'Jenna, 12',
      caption: "I'm excited to see a woman go to the moon because it makes me feel ambitious."
    },
    {
      img: photo6,
      name: 'Valini, 13',
      caption:
        'I find the possibility of life outside our planet exciting. After all, we can’t be the only organisms in our universe!'
    },
    {
      img: photo7,
      name: 'Bhavishyaa, 13',
      caption:
        'Space is an endless possibility to be explored — filled with scientific wonders that can transform our understanding of creation eternally.'
    },
    {
      img: photo8,
      name: 'Nwanyabuife, 13',
      caption:
        'Seeing a woman going to space inspires more women to go to space and for us to discover more.'
    }
  ];
  const length = photos.length - 1;
  const [current, setCurrent] = useState(0);
  const [currentLeft, setCurrentLeft] = useState(length);
  const [currentRight, setCurrentRight] = useState(1);
  const [animateCurrent, setAnimateEra] = useState(1);
  const [animateLeft, setAnimateLeft] = useState(0);
  const [animateRight, setAnimateRight] = useState(2);
  const [queueLeft, setQueueLeft] = useState(length - 1);
  const [queueRight, setQueueRight] = useState(3);
  const [currentCaption, setCurrentCaption] = useState(current);

  const currentRightRef = useRef();
  const currentLeftRef = useRef();
  const currentRef = useRef();
  const queueRightRef = useRef();
  const queueLeftRef = useRef();
  const animationRef = useRef();
  const actualRef = useRef();
  const captionRef = useRef();

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClick('right'),
    onSwipedRight: () => handleClick('left')
  });

  const handleClick = (direction) => {
    window.dataLayer.push({ event: 'carousel_direction' });
    actualRef.current.style.opacity = '0';
    animationRef.current.style.opacity = '1';
    captionRef.current.style.animation = 'fade-out 0.6s linear forwards';

    if (direction === 'left') {
      queueLeftRef.current.style.opacity = 1;
      setCurrent(currentLeft);
      setCurrentLeft(currentLeft === 0 ? length : currentLeft - 1);
      setCurrentRight(current);
      currentLeftRef.current.style.animation = 'moveRightAndScaleUp 0.9s linear';
      currentRef.current.style.animation = 'moveRightAndScaleDown 0.9s linear';
      // currentRightRef.current.style.animation = 'fade-out 0.9s ease-out';
      currentRightRef.current.style.opacity = '0';
      queueLeftRef.current.style.animation = 'moveLeft 0.9s linear';
    } else if (direction === 'right') {
      queueRightRef.current.style.opacity = 1;
      setCurrent(currentRight);
      setCurrentLeft(current);
      setCurrentRight(currentRight === length ? 0 : currentRight + 1);
      currentRightRef.current.style.animation = 'moveLeftAndScaleUp 0.9s linear';
      currentRef.current.style.animation = 'moveLeftAndScaleDown 0.9s linear';
      // currentLeftRef.current.style.animation = 'fade-out 0.9s ease-out';
      currentLeftRef.current.style.opacity = '0';
      queueRightRef.current.style.animation = 'moveRight 0.9s linear';
    }
  };
  useEffect(() => {
    setTimeout(() => {
      actualRef.current.style.opacity = 1;
      animationRef.current.style.opacity = 0;
      queueLeftRef.current.style.opacity = 0;
      queueRightRef.current.style.opacity = 0;
      setCurrentCaption(current);
    }, 900);
    setTimeout(() => {
      setAnimateEra(current);
      setAnimateLeft(currentLeft);
      setAnimateRight(currentRight);
      setQueueLeft(currentLeft === 0 ? length : currentLeft - 1);
      setQueueRight(currentRight === length ? 0 : currentRight + 1);
      currentLeftRef.current.style.animation = '';
      currentLeftRef.current.style.opacity = 1;
      currentRef.current.style.animation = '';
      currentRightRef.current.style.animation = '';
      currentRightRef.current.style.opacity = 1;
      queueLeftRef.current.style.animation = '';
      queueRightRef.current.style.animation = '';
      captionRef.current.style.opacity = '1';
      captionRef.current.style.animation = 'fade-in 0.9s linear forwards';
    }, 1000);
  }, [current, currentLeft, currentRight, length]);

  return (
    <div className="carousel" {...handlers}>
      <div className="carousel__photos" ref={actualRef}>
        <div className={showArrow ? 'arrows' : 'arrows arrows--hideForMobile'}>
          <img
            src={arrow}
            alt="left arrow"
            className="arrows__arrow arrows__arrow--left"
            onClick={() => {
              handleClick('left');
            }}
          />
          <img
            src={arrow}
            alt="right arrow"
            className="arrows__arrow arrows__arrow--right"
            onClick={() => {
              handleClick('right');
            }}
          />
        </div>
        <figure className="carousel__photos__photo carousel__photos__photo-side">
          <img
            src={photos[currentLeft].img}
            alt={photos[currentLeft].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[currentLeft].name}
            </figcaption>
          </div>
        </figure>
        <figure className="carousel__photos__photo carousel__photos__photo-center">
          <img
            src={photos[current].img}
            alt={photos[current].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-center"
          />
          <div className="carousel__photos__photo__caption carousel__photos__photo__caption-center">
            <figcaption className="carousel__photos__photo__caption__text">
              {photos[current].name}
            </figcaption>
          </div>
        </figure>
        <figure className="carousel__photos__photo carousel__photos__photo-side">
          <img
            src={photos[currentRight].img}
            alt={photos[currentRight].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[currentRight].name}
            </figcaption>
          </div>
        </figure>
      </div>
      <div className="carousel__photos carousel__photos-animation" ref={animationRef}>
        <figure className="carousel__photos__photo" ref={currentLeftRef}>
          <img
            src={photos[animateLeft].img}
            alt={photos[animateLeft].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[animateLeft].name}
            </figcaption>
          </div>
        </figure>
        <figure
          className="carousel__photos__photo  carousel__photos__photo-queue"
          ref={queueLeftRef}
        >
          <img
            src={photos[queueLeft].img}
            alt={photos[queueLeft].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side carousel__photos__photo__img-queue"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[queueLeft].name}
            </figcaption>
          </div>
        </figure>
        <figure
          className="carousel__photos__photo  carousel__photos__photo-queue"
          ref={queueRightRef}
        >
          <img
            src={photos[queueRight].img}
            alt={photos[queueRight].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side carousel__photos__photo__img-queue"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[queueRight].name}
            </figcaption>
          </div>
        </figure>
        <figure className="carousel__photos__photo carousel__photos__photo-center" ref={currentRef}>
          <img
            src={photos[animateCurrent].img}
            alt={photos[animateCurrent].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-center"
          />
          <div className="carousel__photos__photo__caption carousel__photos__photo__caption-center">
            <figcaption className="carousel__photos__photo__caption__text ">
              {photos[animateCurrent].name}
            </figcaption>
          </div>
        </figure>
        <figure className="carousel__photos__photo" ref={currentRightRef}>
          <img
            src={photos[animateRight].img}
            alt={photos[animateRight].name}
            className="carousel__photos__photo__img carousel__photos__photo__img-side"
          />
          <div className="carousel__photos__photo__caption">
            <figcaption className="carousel__photos__photo__caption__text carousel__photos__photo__caption__text-side">
              {photos[animateRight].name}
            </figcaption>
          </div>
        </figure>
      </div>

      <p ref={captionRef}>“{photos[currentCaption].caption}”</p>
      <div className="carousel__indicator">
        {photos.map((content, i) => {
          return (
            <svg
              key={i}
              className={
                current === i
                  ? 'carousel__indicator__circle carousel__indicator__circle-active'
                  : 'carousel__indicator__circle'
              }
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
            >
              <title>circle</title>
              <circle cx="8" cy="8" r="6" />
            </svg>
          );
        })}
      </div>
    </div>
  );
}

export default Carousel;
